import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '@bibliocommons/base-buttons';
import { ArrowBack } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './BackToLink.scss';

function renderArrowBack() {
  return <ArrowBack />;
}

export default function BackToLink() {
  return (
    <div className="cp-back-to-link">
      <TextButton dataKey="back-to-link" renderLeadingIcon={renderArrowBack}>
        <span aria-hidden>
          <FormattedMessage id="search_results" />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="sr_search_results" />
        </ScreenReaderMessage>
      </TextButton>
    </div>
  );
}
